import React, {Component} from 'react'

import HomeBackground from "../components/HomeBackground";
import Section from "../components/Section";
import Skill from "../components/Skill";
import Score from "../components/Score";
import Timeline from "../components/Timeline";
import Footer from "../components/Footer";
import Version from "../components/Version";

import {introduction, posts, scores, skills, timelines} from "../constants/data";
// import FloatButton from "../components/FloatButton";

class HomePage extends Component {
    render() {
        return (
            <div>
                <Version visible version={"Ver 0.4.2"}/>
                <HomeBackground/>
                <Section id={'about-me'} title={'About Me'}>
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <p>{introduction[0].content}</p>
                        </div>
                        <div className="col-12 col-md-4">
                            <p>{introduction[1].content}</p>
                        </div>
                        <div className="col-12 col-md-4">
                            {
                                skills.map((item) => {
                                    return (
                                        <Skill key={item.id} name={item.name} rate={item.rate}/>
                                    )
                                })
                            }
                        </div>
                    </div>
                    <div className="row margin-top-70 text-center">
                        {
                            scores.map((item) => {
                                return (
                                    <div key={item.id} className="col-6 col-md-4 col-lg-2">
                                        <Score name={item.name} score={item.score}/>
                                    </div>
                                )
                            })
                        }
                    </div>
                </Section>
                <Section title={'Posts'} lighter>
                    <div className="portfolio-wrapper column-3 spacing-10">
                        {
                            posts.map((item) => {
                                return (
                                    <div>none</div>
                                )
                            })
                        }
                    </div>
                </Section>
                <Section title={'Resume'}>
                    <div className="timeline-wrapper">
                        {
                            timelines.map((item) => {
                                return (
                                    <Timeline
                                        key={item.id}
                                        from={item.from}
                                        to={item.to}
                                        title={item.title}
                                        description={item.description}
                                    />
                                )
                            })
                        }
                    </div>
                </Section>
                {/*<FloatButton/>*/}
                <Footer/>
            </div>
        )
    }
}

export default HomePage